import loadjs from 'loadjs';
import { loadAPI } from '../api/google-maps';

class AddressQas {
  constructor(el) {
    this.el = el;
    this.manualTrigger = this.el.find('[data-qas-manualtrigger]');
    this.autocomplete = this.el.find('[data-qas-autocomplete]');
    this.mapsAutocomplete = { unbindAll: () => {} };
    this.country = this.el.find(
      '[name="country"],[name="recipient-addr-country"]',
    );
    this.street = this.el.find(
      '[name="street"],[name="recipient-addr-street"]',
    );
    this.suburb = this.el.find(
      '[name="suburb"],[name="recipient-addr-suburb"]',
    );
    this.state = this.el.find('[name="state"],[name="recipient-addr-state"]');
    this.postcode = this.el.find(
      '[name="postcode"],[name="recipient-addr-postcode"]',
    );
    this.manualFields = this.el.find('[data-qas-manual]');
    this.stateSelect = this.el.find('[data-qas-stateselect]');

    this.ajax = { abort: () => {} };

    this.countryList = {
      AF: 'Afghanistan',
      AX: 'Aland Islands',
      AL: 'Albania',
      DZ: 'Algeria',
      AS: 'American Samoa',
      AD: 'Andorra',
      AO: 'Angola',
      AI: 'Anguilla',
      AQ: 'Antarctica',
      AG: 'Antigua And Barbuda',
      AR: 'Argentina',
      AM: 'Armenia',
      AW: 'Aruba',
      AU: 'Australia',
      AT: 'Austria',
      AZ: 'Azerbaijan',
      BS: 'Bahamas',
      BH: 'Bahrain',
      BD: 'Bangladesh',
      BB: 'Barbados',
      BY: 'Belarus',
      BE: 'Belgium',
      BZ: 'Belize',
      BJ: 'Benin',
      BM: 'Bermuda',
      BT: 'Bhutan',
      BO: 'Bolivia',
      BA: 'Bosnia And Herzegovina',
      BW: 'Botswana',
      BV: 'Bouvet Island',
      BR: 'Brazil',
      IO: 'British Indian Ocean Territory',
      BN: 'Brunei Darussalam',
      BG: 'Bulgaria',
      BF: 'Burkina Faso',
      BI: 'Burundi',
      KH: 'Cambodia',
      CM: 'Cameroon',
      CA: 'Canada',
      CV: 'Cape Verde',
      KY: 'Cayman Islands',
      CF: 'Central African Republic',
      TD: 'Chad',
      CL: 'Chile',
      CN: 'China',
      CX: 'Christmas Island',
      CC: 'Cocos (Keeling) Islands',
      CO: 'Colombia',
      KM: 'Comoros',
      CG: 'Congo',
      CD: 'Congo, Democratic Republic',
      CK: 'Cook Islands',
      CR: 'Costa Rica',
      CI: "Cote D'Ivoire",
      HR: 'Croatia',
      CU: 'Cuba',
      CY: 'Cyprus',
      CZ: 'Czech Republic',
      DK: 'Denmark',
      DJ: 'Djibouti',
      DM: 'Dominica',
      DO: 'Dominican Republic',
      EC: 'Ecuador',
      EG: 'Egypt',
      SV: 'El Salvador',
      GQ: 'Equatorial Guinea',
      ER: 'Eritrea',
      EE: 'Estonia',
      ET: 'Ethiopia',
      FK: 'Falkland Islands (Malvinas)',
      FO: 'Faroe Islands',
      FJ: 'Fiji',
      FI: 'Finland',
      FR: 'France',
      GF: 'French Guiana',
      PF: 'French Polynesia',
      TF: 'French Southern Territories',
      GA: 'Gabon',
      GM: 'Gambia',
      GE: 'Georgia',
      DE: 'Germany',
      GH: 'Ghana',
      GI: 'Gibraltar',
      GR: 'Greece',
      GL: 'Greenland',
      GD: 'Grenada',
      GP: 'Guadeloupe',
      GU: 'Guam',
      GT: 'Guatemala',
      GG: 'Guernsey',
      GN: 'Guinea',
      GW: 'Guinea-Bissau',
      GY: 'Guyana',
      HT: 'Haiti',
      HM: 'Heard Island & Mcdonald Islands',
      VA: 'Holy See (Vatican City State)',
      HN: 'Honduras',
      HK: 'Hong Kong',
      HU: 'Hungary',
      IS: 'Iceland',
      IN: 'India',
      ID: 'Indonesia',
      IR: 'Iran, Islamic Republic Of',
      IQ: 'Iraq',
      IE: 'Ireland',
      IM: 'Isle Of Man',
      IL: 'Israel',
      IT: 'Italy',
      JM: 'Jamaica',
      JP: 'Japan',
      JE: 'Jersey',
      JO: 'Jordan',
      KZ: 'Kazakhstan',
      KE: 'Kenya',
      KI: 'Kiribati',
      KR: 'Korea',
      KW: 'Kuwait',
      KG: 'Kyrgyzstan',
      LA: "Lao People's Democratic Republic",
      LV: 'Latvia',
      LB: 'Lebanon',
      LS: 'Lesotho',
      LR: 'Liberia',
      LY: 'Libyan Arab Jamahiriya',
      LI: 'Liechtenstein',
      LT: 'Lithuania',
      LU: 'Luxembourg',
      MO: 'Macao',
      MK: 'Macedonia',
      MG: 'Madagascar',
      MW: 'Malawi',
      MY: 'Malaysia',
      MV: 'Maldives',
      ML: 'Mali',
      MT: 'Malta',
      MH: 'Marshall Islands',
      MQ: 'Martinique',
      MR: 'Mauritania',
      MU: 'Mauritius',
      YT: 'Mayotte',
      MX: 'Mexico',
      FM: 'Micronesia, Federated States Of',
      MD: 'Moldova',
      MC: 'Monaco',
      MN: 'Mongolia',
      ME: 'Montenegro',
      MS: 'Montserrat',
      MA: 'Morocco',
      MZ: 'Mozambique',
      MM: 'Myanmar',
      NA: 'Namibia',
      NR: 'Nauru',
      NP: 'Nepal',
      NL: 'Netherlands',
      AN: 'Netherlands Antilles',
      NC: 'New Caledonia',
      NZ: 'New Zealand',
      NI: 'Nicaragua',
      NE: 'Niger',
      NG: 'Nigeria',
      NU: 'Niue',
      NF: 'Norfolk Island',
      MP: 'Northern Mariana Islands',
      NO: 'Norway',
      OM: 'Oman',
      PK: 'Pakistan',
      PW: 'Palau',
      PS: 'Palestinian Territory, Occupied',
      PA: 'Panama',
      PG: 'Papua New Guinea',
      PY: 'Paraguay',
      PE: 'Peru',
      PH: 'Philippines',
      PN: 'Pitcairn',
      PL: 'Poland',
      PT: 'Portugal',
      PR: 'Puerto Rico',
      QA: 'Qatar',
      RE: 'Reunion',
      RO: 'Romania',
      RU: 'Russian Federation',
      RW: 'Rwanda',
      BL: 'Saint Barthelemy',
      SH: 'Saint Helena',
      KN: 'Saint Kitts And Nevis',
      LC: 'Saint Lucia',
      MF: 'Saint Martin',
      PM: 'Saint Pierre And Miquelon',
      VC: 'Saint Vincent And Grenadines',
      WS: 'Samoa',
      SM: 'San Marino',
      ST: 'Sao Tome And Principe',
      SA: 'Saudi Arabia',
      SN: 'Senegal',
      RS: 'Serbia',
      SC: 'Seychelles',
      SL: 'Sierra Leone',
      SG: 'Singapore',
      SK: 'Slovakia',
      SI: 'Slovenia',
      SB: 'Solomon Islands',
      SO: 'Somalia',
      ZA: 'South Africa',
      GS: 'South Georgia And Sandwich Isl.',
      ES: 'Spain',
      LK: 'Sri Lanka',
      SD: 'Sudan',
      SR: 'Suriname',
      SJ: 'Svalbard And Jan Mayen',
      SZ: 'Swaziland',
      SE: 'Sweden',
      CH: 'Switzerland',
      SY: 'Syrian Arab Republic',
      TW: 'Taiwan',
      TJ: 'Tajikistan',
      TZ: 'Tanzania',
      TH: 'Thailand',
      TL: 'Timor-Leste',
      TG: 'Togo',
      TK: 'Tokelau',
      TO: 'Tonga',
      TT: 'Trinidad And Tobago',
      TN: 'Tunisia',
      TR: 'Turkey',
      TM: 'Turkmenistan',
      TC: 'Turks And Caicos Islands',
      TV: 'Tuvalu',
      UG: 'Uganda',
      UA: 'Ukraine',
      AE: 'United Arab Emirates',
      GB: 'United Kingdom',
      US: 'United States',
      UM: 'United States Outlying Islands',
      UY: 'Uruguay',
      UZ: 'Uzbekistan',
      VU: 'Vanuatu',
      VE: 'Venezuela',
      VN: 'Viet Nam',
      VG: 'Virgin Islands, British',
      VI: 'Virgin Islands, U.S.',
      WF: 'Wallis And Futuna',
      EH: 'Western Sahara',
      YE: 'Yemen',
      ZM: 'Zambia',
      ZW: 'Zimbabwe',
    };
    this.australianStates = {
      '': '',
      ACT: 'Australian Capital Territory',
      NSW: 'New South Wales',
      NT: 'Northern Territory',
      QLD: 'Queensland',
      SA: 'South Australia',
      TAS: 'Tasmania',
      VIC: 'Victoria',
      WA: 'Western Australia',
    };

    this.fillMapsAddress = this.fillMapsAddress.bind(this);

    loadAPI().then(() => {
      this.events();
      // this.populateStates();
      this.populateCountryList();
    });
  }

  events() {
    this.country.on('change', (e) => {
      this.hideManualFields();
      this.autocomplete.val('');
      if ($(e.currentTarget).val() === 'Australia') {
        this.setupAutocomplete();
        this.setupStateField(true);
      } else {
        this.setupMapsComplete();
        this.setupStateField();
      }
    });
    /*
    this.stateSelect.on('change', e => {
      if (this.country.val() === 'Australia') {
        this.state.val($(e.currentTarget).val());
      }
    });
*/
    this.manualTrigger.on('click', () => {
      this.showManualFields();

      this.manualFields.find('input').first().focus();
    });
  }

  setupStateField() {
    // australia = false
    /*
    this.state.val('');
    this.stateSelect.val('');
    if (australia) {
      this.state.hide();
      this.stateSelect.show();
    } else {
      this.stateSelect.hide();
      this.state.show();
    }
    */
  }

  hideManualFields() {
    this.autocomplete.parent().show();
    this.manualFields.hide();
    this.manualFields.find('input,select').val('');
  }

  showManualFields() {
    this.manualFields.show();
    this.autocomplete.parent().hide();
  }

  triggerLoading() {
    this.el.closest('form').trigger('addressLoadingStart');
  }

  triggerUnloading() {
    this.el.closest('form').trigger('addressLoadingStop');
  }

  populateAddress($selectedAddress) {
    this.triggerLoading();
    $.ajax({
      type: 'GET',
      url: `${guidedogsGlobals.gdresturl}qas-address/doGetAddress/`,
      dataType: 'json',
      data: {
        moniker: $selectedAddress,
      },
      success: (data) => {
        this.el.children('#hidden-street-2').remove();

        this.street.val(data.payload['street-1']);
        this.suburb.val(data.payload.city);
        this.stateSelect.val(data.payload['state-province']);
        this.stateSelect.trigger('change');
        this.stateSelect.each((index, element) => {
          element.dispatchEvent(new Event('change'));
        });
        this.postcode.val(data.payload['zip-postal-code']);
        this.validated = true;

        if (data.payload['street-2']) {
          this.el.append(
            `<input id="hidden-street-2" type="hidden" name="street-2" value="${data.payload['street-2']}" />`,
          );
        }
      },
      complete: () => {
        this.triggerUnloading();
      },
    });
  }

  populateCountryList() {
    $.each(this.countryList, (key, value) => {
      const option = $('<option>').attr('value', value).text(value);

      if (key === 'AU') {
        option.attr('selected', true);
      }

      this.country.append(option);
    });
    this.country.trigger('change');
  }

  populateStates() {
    $.each(this.australianStates, (key, value) => {
      const option = $('<option>').attr('value', key).text(value);

      this.stateSelect.append(option);
    });

    this.stateSelect.insertAfter(this.state);

    this.stateSelect.hide();
  }

  getCountryKeyByValue(country) {
    return Object.keys(this.countryList).find(
      (key) => this.countryList[key] === country,
    );
  }

  unbindGoogleMapsAutocomplete() {
    this.mapsAutocomplete.unbindAll();
    google.maps.event.clearInstanceListeners(this.autocomplete[0]);
    this.mapsAutocomplete = { unbindAll: () => {} };
  }

  setupMapsComplete() {
    if (this.autocomplete.autocomplete('instance') !== undefined) {
      this.autocomplete.autocomplete('destroy');
    }

    this.unbindGoogleMapsAutocomplete();

    this.mapsAutocomplete = new google.maps.places.Autocomplete(
      this.autocomplete[0],
      {
        types: ['geocode'],
        componentRestrictions: {
          country: this.getCountryKeyByValue(this.country.val()),
        },
      },
    );

    this.mapsAutocomplete.addListener('place_changed', this.fillMapsAddress);
  }

  setupAutocomplete() {
    this.unbindGoogleMapsAutocomplete();

    this.autocomplete
      .autocomplete({
        minLength: 4,
        source: (request, response) => {
          this.triggerLoading();
          $.ajax({
            type: 'GET',
            url: `${guidedogsGlobals.gdresturl}qas-address/autocomplete/`,
            data: {
              search: request.term,
            },
            dataType: 'json',
            success(data) {
              const matches_keys = Object.keys(data.payload);
              const matches_array = [];
              for (
                let i = 0;
                i < matches_keys.length && matches_keys[i] !== '';
                i += 1
              ) {
                matches_array.push({
                  label: data.payload[matches_keys[i]],
                  value: matches_keys[i],
                });
              }

              matches_array.push({
                label: 'Enter Address Manually',
                value: 'Enter Address Manually',
              });

              response(matches_array);
            },
            complete: () => {
              this.triggerUnloading();
            },
          });
        },
        focus(e, ui) {
          $('.ui-helper-hidden-accessible').empty().append(ui.item.label);
          e.preventDefault();
        },
        select: (event, ui) => {
          this.hideManualFields();
          if (ui.item.label === 'Enter Address Manually') {
            this.showManualFields();
          } else {
            this.populateAddress(ui.item.value);
            // this.showManualFields(); //TODO show readonly?

            ui.item.value = ui.item.label;
          }
        },
      })
      .autocomplete('instance')._renderItem = function (ul, item) {
      return $('<li>')
        .data('ui-autocomplete-item', item)

        .append(
          item.label === 'Enter Address Manually'
            ? `<div><span></span>Can't find your address? <span style='color:#f7901e;font-weight:bold;'> ${item.label}</span></div>`
            : `<div><span>${item.label}</span><span></span></div>`,
        )

        .appendTo(ul);
    };

    this.autocomplete.attr('autocomplete', 'new-password');
  }

  fillMapsAddress() {
    const place = this.mapsAutocomplete.getPlace();

    const $addr = $(`<div>${place.adr_address}</div>`);

    try {
      this.street.val($addr.find('span.street-address').text());
      this.suburb.val($addr.find('span.locality').text());
      this.state.val($addr.find('span.region').text());
      this.postcode.val($addr.find('span.postal-code').text());

      this.state.each((index, element) => {
        element.dispatchEvent(new Event('change'));
      });

      this.showManualFields();
    } catch (e) {
      console.log(`error: ${e}`);
    }

    // switchInputMethod();
  }
}

export default function init() {
  if ($('[data-js-address-qas]').length <= 0) {
    return false;
  }

  loadjs(
    [
      `${guidedogsGlobals.iconPath}/js/async-libs/jquery-ui.min.js`,
      `${guidedogsGlobals.iconPath}/js/async-libs/css/jquery-ui.min.css`,
    ],
    () => {
      $('[data-js-address-qas]').each((index, container) => {
        new AddressQas($(container));
      });
    },
  );

  return null;
}
